var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoRequiredIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.311,
    height: 140.311,
    viewBox: "0 0 140.311 140.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9295",
    "data-name": "Group 9295",
    transform: "translate(-1068.846 -241.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_check_boxes_re_v40f_1_",
    "data-name": "undraw_check_boxes_re_v40f (1)",
    transform: "translate(1068.846 244.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_533",
    "data-name": "Ellipse 533",
    cx: 70.155,
    cy: 70.155,
    r: 70.155,
    transform: "translate(0 -2.335)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_534",
    "data-name": "Ellipse 534",
    cx: 58.463,
    cy: 58.463,
    r: 58.463,
    transform: "translate(11.693 9.358)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9294",
    "data-name": "Group 9294",
    transform: "translate(918.086 -190.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12906",
    "data-name": "Path 12906",
    d: "M10.3.032C8.784.105,7.076,1.548,5.328,3.044A15.315,15.315,0,0,0,1.48,7.154C.262,9.1-.556,10.241.456,11.744c1.4,1.045,1.549,1.55,4.418.408,2.635-.7,2.815-1,4.764-.421s4.562,4.387,5.49,5.366a93.225,93.225,0,0,0,6.343,9.04c3.031,3.639,5.3,4.939,8.233,4.373,2.409-.792,3.294-1.867,4.482-4.18,1.307-2.186,2.54-14.13.088-16.277-.795-.7-2.811.368-3.939,1.868-1.2,1.59-1.2,3.179-2.9,4.514-1.257.787-3.056-1.469-3.838-2.145-1.782-1.58-5.752-8.257-8.173-11.375S11.737-.051,10.3.032Z",
    transform: "translate(218.314 485.148) rotate(43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13698",
    "data-name": "Path 13698",
    d: "M6.791,2.671c2.324-.675,6.181.9,7.256,4.988S12.8,14.745,8.209,14.745s-7.6-.628-7.6-5.215S4.466,3.346,6.791,2.671Z",
    transform: "translate(213.905 469.654)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRequiredIcon);
export default __webpack_public_path__ + "static/media/info_required_icon.2777f92e7de3babf1ad65221b26f8991.svg";
export { ForwardRef as ReactComponent };